import React, {Fragment, useEffect, useRef} from 'react';
import {Col, Icon, Row} from "antd";

const DEFAULT_DELAY = 1000;

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

const UpdatedStatusGetter = ({
                               enabled,
                               callback,
                               callbackParam,
                               status,
                               getStepLabel,
                               fishedWithError
                             }) => {

  const prevEnabled = usePrevious(enabled);

  useEffect(() => {
    if (callback) {
      if (enabled) {
        setTimeout(callback, DEFAULT_DELAY, callbackParam);
      } else {
        if (prevEnabled) {
          callback(callbackParam);
        }
      }
    }
  }, [enabled, callback, callbackParam, status]);

  const okIcon = (
    <Icon
      type={'check-circle'}
      theme="filled"
      style={{
        marginLeft: 8,
        color: 'green'
      }}
    />
  );

  const errorIcon = (
    <Icon
      type={'close-circle'}
      theme="filled"
      style={{
        marginLeft: 8,
        color: 'red'
      }}
    />
  );

  return (
    <Fragment>
      {(status || []).map((step, idx) =>
        <Row key={idx} type="flex" justify="center" style={{padding: 4}}>
          <Col>
            <i>
              {(getStepLabel && getStepLabel(step))
                ? getStepLabel(step)
                : step
              }
            </i>
            {(idx < status.length - 1)
              ? okIcon
              : enabled
                ? "..."
                : fishedWithError
                  ? errorIcon
                  : okIcon
            }
          </Col>
        </Row>
      )}
    </Fragment>
  )
};

export default UpdatedStatusGetter;



// WEBPACK FOOTER //
// ./src/components/updated-status-getter/index.jsx